<template>
  <div class="animation-stars">
    <div class="stars"></div>
  </div>
</template>

<script>
export default {
  name: 'stars',
  components: {},
  props: [],
  data() {
    return {}
  },
  watch: {},
  computed: {},
  created() {},
  mounted() {},
  methods: {},
}
</script>

<style lang="scss" scoped>
.animation-stars {
  $star-color: #fff;

  @keyframes anim-star {
    from {
      transform: translateY(0px);
    }
    to {
      transform: translateY(-2000px);
    }
  }

  position: fixed;

  .stars {
    width: 1px;
    height: 1px;
    background: transparent;
    box-shadow: 1407px 511px $star-color, 1611px 119px $star-color,
      1686px 956px $star-color, 1163px 1929px $star-color,
      912px 1242px $star-color, 490px 469px $star-color, 869px 425px $star-color,
      1447px 891px $star-color, 422px 1960px $star-color,
      517px 1995px $star-color, 738px 171px $star-color,
      1328px 1668px $star-color, 874px 1490px $star-color, 83px 81px $star-color,
      632px 98px $star-color, 1518px 1764px $star-color, 636px 596px $star-color,
      1178px 131px $star-color, 278px 1179px $star-color,
      1898px 1951px $star-color, 1787px 326px $star-color,
      186px 1588px $star-color, 552px 1942px $star-color,
      1929px 1300px $star-color, 802px 681px $star-color,
      430px 1711px $star-color, 1192px 308px $star-color,
      123px 1604px $star-color, 880px 169px $star-color,
      1400px 632px $star-color, 500px 1165px $star-color,
      288px 1208px $star-color, 319px 1419px $star-color,
      1170px 980px $star-color, 1608px 784px $star-color,
      1735px 1276px $star-color, 966px 1534px $star-color,
      654px 783px $star-color, 1366px 964px $star-color, 1213px 60px $star-color,
      302px 1509px $star-color, 845px 714px $star-color, 524px 323px $star-color,
      1538px 1399px $star-color, 394px 619px $star-color, 680px 26px $star-color,
      353px 776px $star-color, 1826px 1450px $star-color,
      1909px 1452px $star-color, 1014px 1315px $star-color,
      1883px 1474px $star-color, 766px 1742px $star-color,
      1693px 658px $star-color, 1186px 302px $star-color,
      376px 1575px $star-color, 712px 1739px $star-color,
      1627px 299px $star-color, 482px 224px $star-color,
      1379px 510px $star-color, 1543px 1602px $star-color,
      45px 606px $star-color, 827px 1336px $star-color, 224px 1939px $star-color,
      1098px 1342px $star-color, 813px 1553px $star-color,
      825px 419px $star-color, 519px 894px $star-color, 1406px 797px $star-color,
      1341px 274px $star-color, 1787px 903px $star-color,
      1701px 1483px $star-color, 1108px 232px $star-color,
      1599px 1409px $star-color, 659px 870px $star-color,
      1538px 335px $star-color, 632px 1855px $star-color,
      154px 1026px $star-color, 1722px 979px $star-color,
      1339px 509px $star-color, 1833px 460px $star-color, 315px 65px $star-color,
      496px 1927px $star-color, 1314px 427px $star-color,
      344px 1046px $star-color, 1658px 724px $star-color,
      1899px 264px $star-color, 1200px 1305px $star-color,
      1562px 339px $star-color, 159px 766px $star-color,
      1639px 1966px $star-color, 459px 1898px $star-color,
      944px 763px $star-color, 1174px 1056px $star-color,
      1825px 790px $star-color, 906px 1526px $star-color,
      1537px 1303px $star-color, 79px 1105px $star-color,
      1318px 672px $star-color, 1232px 61px $star-color,
      709px 1078px $star-color, 1010px 1810px $star-color,
      777px 1160px $star-color, 1598px 1428px $star-color,
      815px 684px $star-color, 1003px 943px $star-color,
      1876px 1003px $star-color, 1025px 1529px $star-color,
      66px 549px $star-color, 514px 457px $star-color, 262px 1005px $star-color,
      812px 1705px $star-color, 1163px 1087px $star-color,
      165px 45px $star-color, 677px 1462px $star-color, 580px 1675px $star-color,
      1848px 1384px $star-color, 449px 862px $star-color,
      1629px 1979px $star-color, 667px 135px $star-color, 240px 53px $star-color,
      1919px 1832px $star-color, 696px 1384px $star-color,
      1630px 361px $star-color, 878px 663px $star-color,
      1226px 1723px $star-color, 765px 686px $star-color,
      576px 1647px $star-color, 97px 1602px $star-color,
      1117px 1049px $star-color, 1433px 68px $star-color,
      1375px 1991px $star-color, 1755px 990px $star-color,
      1483px 801px $star-color, 473px 1802px $star-color,
      822px 768px $star-color, 196px 577px $star-color, 516px 504px $star-color,
      623px 981px $star-color, 1478px 819px $star-color, 126px 384px $star-color,
      584px 1908px $star-color, 1549px 521px $star-color,
      1866px 1335px $star-color, 586px 342px $star-color,
      1698px 642px $star-color, 136px 188px $star-color,
      1613px 520px $star-color, 937px 326px $star-color,
      1111px 169px $star-color, 229px 229px $star-color, 1357px 20px $star-color,
      725px 1305px $star-color, 23px 1977px $star-color,
      426px 1945px $star-color, 1628px 1530px $star-color,
      256px 1295px $star-color, 58px 78px $star-color, 409px 1145px $star-color,
      1607px 767px $star-color, 212px 144px $star-color,
      361px 1890px $star-color, 1827px 1451px $star-color,
      1875px 645px $star-color, 571px 853px $star-color,
      1302px 301px $star-color, 9px 1344px $star-color, 418px 619px $star-color,
      1941px 90px $star-color, 949px 640px $star-color, 179px 1783px $star-color,
      1104px 360px $star-color, 1723px 370px $star-color,
      1122px 1418px $star-color, 1374px 508px $star-color,
      1108px 1089px $star-color, 1440px 1743px $star-color,
      462px 1495px $star-color, 1187px 265px $star-color, 567px 74px $star-color,
      557px 542px $star-color, 967px 673px $star-color, 825px 1971px $star-color,
      988px 1260px $star-color, 710px 1206px $star-color,
      538px 1805px $star-color, 137px 861px $star-color,
      1922px 1313px $star-color, 481px 470px $star-color,
      1224px 316px $star-color, 1979px 239px $star-color,
      22px 1155px $star-color, 1640px 186px $star-color,
      592px 1709px $star-color, 765px 170px $star-color,
      129px 1750px $star-color, 788px 719px $star-color,
      181px 1327px $star-color, 433px 1455px $star-color,
      141px 450px $star-color, 1287px 1027px $star-color,
      1278px 1462px $star-color;
    animation: anim-star 50s linear infinite;
  }

  .stars:after {
    content: ' ';
    position: absolute;
    top: 2000px;
    width: 1px;
    height: 1px;
    background: transparent;
    box-shadow: 1407px 511px $star-color, 1611px 119px $star-color,
      1686px 956px $star-color, 1163px 1929px $star-color,
      912px 1242px $star-color, 490px 469px $star-color, 869px 425px $star-color,
      1447px 891px $star-color, 422px 1960px $star-color,
      517px 1995px $star-color, 738px 171px $star-color,
      1328px 1668px $star-color, 874px 1490px $star-color, 83px 81px $star-color,
      632px 98px $star-color, 1518px 1764px $star-color, 636px 596px $star-color,
      1178px 131px $star-color, 278px 1179px $star-color,
      1898px 1951px $star-color, 1787px 326px $star-color,
      186px 1588px $star-color, 552px 1942px $star-color,
      1929px 1300px $star-color, 802px 681px $star-color,
      430px 1711px $star-color, 1192px 308px $star-color,
      123px 1604px $star-color, 880px 169px $star-color,
      1400px 632px $star-color, 500px 1165px $star-color,
      288px 1208px $star-color, 319px 1419px $star-color,
      1170px 980px $star-color, 1608px 784px $star-color,
      1735px 1276px $star-color, 966px 1534px $star-color,
      654px 783px $star-color, 1366px 964px $star-color, 1213px 60px $star-color,
      302px 1509px $star-color, 845px 714px $star-color, 524px 323px $star-color,
      1538px 1399px $star-color, 394px 619px $star-color, 680px 26px $star-color,
      353px 776px $star-color, 1826px 1450px $star-color,
      1909px 1452px $star-color, 1014px 1315px $star-color,
      1883px 1474px $star-color, 766px 1742px $star-color,
      1693px 658px $star-color, 1186px 302px $star-color,
      376px 1575px $star-color, 712px 1739px $star-color,
      1627px 299px $star-color, 482px 224px $star-color,
      1379px 510px $star-color, 1543px 1602px $star-color,
      45px 606px $star-color, 827px 1336px $star-color, 224px 1939px $star-color,
      1098px 1342px $star-color, 813px 1553px $star-color,
      825px 419px $star-color, 519px 894px $star-color, 1406px 797px $star-color,
      1341px 274px $star-color, 1787px 903px $star-color,
      1701px 1483px $star-color, 1108px 232px $star-color,
      1599px 1409px $star-color, 659px 870px $star-color,
      1538px 335px $star-color, 632px 1855px $star-color,
      154px 1026px $star-color, 1722px 979px $star-color,
      1339px 509px $star-color, 1833px 460px $star-color, 315px 65px $star-color,
      496px 1927px $star-color, 1314px 427px $star-color,
      344px 1046px $star-color, 1658px 724px $star-color,
      1899px 264px $star-color, 1200px 1305px $star-color,
      1562px 339px $star-color, 159px 766px $star-color,
      1639px 1966px $star-color, 459px 1898px $star-color,
      944px 763px $star-color, 1174px 1056px $star-color,
      1825px 790px $star-color, 906px 1526px $star-color,
      1537px 1303px $star-color, 79px 1105px $star-color,
      1318px 672px $star-color, 1232px 61px $star-color,
      709px 1078px $star-color, 1010px 1810px $star-color,
      777px 1160px $star-color, 1598px 1428px $star-color,
      815px 684px $star-color, 1003px 943px $star-color,
      1876px 1003px $star-color, 1025px 1529px $star-color,
      66px 549px $star-color, 514px 457px $star-color, 262px 1005px $star-color,
      812px 1705px $star-color, 1163px 1087px $star-color,
      165px 45px $star-color, 677px 1462px $star-color, 580px 1675px $star-color,
      1848px 1384px $star-color, 449px 862px $star-color,
      1629px 1979px $star-color, 667px 135px $star-color, 240px 53px $star-color,
      1919px 1832px $star-color, 696px 1384px $star-color,
      1630px 361px $star-color, 878px 663px $star-color,
      1226px 1723px $star-color, 765px 686px $star-color,
      576px 1647px $star-color, 97px 1602px $star-color,
      1117px 1049px $star-color, 1433px 68px $star-color,
      1375px 1991px $star-color, 1755px 990px $star-color,
      1483px 801px $star-color, 473px 1802px $star-color,
      822px 768px $star-color, 196px 577px $star-color, 516px 504px $star-color,
      623px 981px $star-color, 1478px 819px $star-color, 126px 384px $star-color,
      584px 1908px $star-color, 1549px 521px $star-color,
      1866px 1335px $star-color, 586px 342px $star-color,
      1698px 642px $star-color, 136px 188px $star-color,
      1613px 520px $star-color, 937px 326px $star-color,
      1111px 169px $star-color, 229px 229px $star-color, 1357px 20px $star-color,
      725px 1305px $star-color, 23px 1977px $star-color,
      426px 1945px $star-color, 1628px 1530px $star-color,
      256px 1295px $star-color, 58px 78px $star-color, 409px 1145px $star-color,
      1607px 767px $star-color, 212px 144px $star-color,
      361px 1890px $star-color, 1827px 1451px $star-color,
      1875px 645px $star-color, 571px 853px $star-color,
      1302px 301px $star-color, 9px 1344px $star-color, 418px 619px $star-color,
      1941px 90px $star-color, 949px 640px $star-color, 179px 1783px $star-color,
      1104px 360px $star-color, 1723px 370px $star-color,
      1122px 1418px $star-color, 1374px 508px $star-color,
      1108px 1089px $star-color, 1440px 1743px $star-color,
      462px 1495px $star-color, 1187px 265px $star-color, 567px 74px $star-color,
      557px 542px $star-color, 967px 673px $star-color, 825px 1971px $star-color,
      988px 1260px $star-color, 710px 1206px $star-color,
      538px 1805px $star-color, 137px 861px $star-color,
      1922px 1313px $star-color, 481px 470px $star-color,
      1224px 316px $star-color, 1979px 239px $star-color,
      22px 1155px $star-color, 1640px 186px $star-color,
      592px 1709px $star-color, 765px 170px $star-color,
      129px 1750px $star-color, 788px 719px $star-color,
      181px 1327px $star-color, 433px 1455px $star-color,
      141px 450px $star-color, 1287px 1027px $star-color,
      1278px 1462px $star-color;
  }
}
</style>